<div class="card__info card__info--primary">
  <span class="card__info__title">{{
    'dashboard-agent-commission-transaction-total.component.total'
      | localise: 'Total'
  }}</span>
  <div class="commission-list">
    @for (item of list?.length ? list : defaultList; track item) {
      <div class="commission-list__item">
        <span class="commission-list__item__year"
          >{{ item.year }}
          {{
            'dashboard-agent-commission-transaction-total.component.ytd_gross'
              | localise: 'YTD Gross'
          }}</span
        >
        <span>{{ item.amount | currencyJs: { showSymbol: true } }}</span>
      </div>
    }
  </div>
  <div class="card__info__actions">
    <button
      mat-flat-button
      class="action-button action-button--primary"
      routerLink="/payroll-settings">
      {{
        'dashboard-agent-commission-transaction-total.component.add_bank_account'
          | localise: 'Add your Bank Account'
      }}
    </button>
  </div>
</div>
